import { Component, Inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { DialogService } from '../../shared/ui/dialog/dialog.service';
import { DIALOG_COMPONENT, DialogComponent } from '../../shared/ui/dialog/dialog.component';
import { IWizardStep } from '../wizard/wizard.component';
import { openDialog, openSnackbar } from '../../store/actions/page.action';
import { InfoTipsComponent } from '../info-tips/info-tips.component';
import {
  SearchForContactComponent,
} from '../wizard/components/red-no-match/search-for-contact/search-for-contact.component';
import {
  CreateNewContactComponent,
} from '../wizard/components/red-no-match/create-new-contact/create-new-contact.component';
import { ButtonColor, ButtonSize } from '../../store/models/button.model';
import { IMessage, IMessageMatchedContact } from '../../store/models/message.model';
import { ContactsService } from '../../store/services/contacts.service';
import { MessageService } from '../../store/services/message.service';
import { HttpErrorResponse } from '@angular/common/http';
import { RContentComponent } from '../quick-response/r-content.component';
import { IUserSessionData } from '../../store/models/user.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-red-no-match-dialog',
  templateUrl: './red-no-match-dialog.component.html',
  styleUrls: ['./red-no-match-dialog.component.scss'],
})
export class RedNoMatchDialogComponent implements OnInit {
  messages: IMessage[];

  contactId: number;

  contactEmail: string;

  contactFirstName: string;

  contactLastName: string;

  dialogRef: DialogComponent;

  wizardSteps: IWizardStep[];

  accountId: number;

  userSession: IUserSessionData;

  matchedContact: IMessageMatchedContact;

  constructor(
    private readonly store$: Store<IReducers>,
    private readonly dialogService: DialogService,
    @Inject(DIALOG_COMPONENT) private readonly dialogComponent: DialogComponent,
    private readonly contactsService: ContactsService,
    private readonly messagesService: MessageService,
    private readonly router: Router,
  ) {
  }

  ngOnInit(): void {
    console.log('here 1', this.matchedContact);
    this.wizardSteps = [
      {
        title: 'Search for existing contact',
        component: SearchForContactComponent,
        id: SearchForContactComponent.ID,
        componentData: {
          messages: this.messages,
          firstName: this.contactFirstName,
          lastName: this.contactLastName,
          accountId: this.accountId,
          contactId: this.contactId,
          matchedContact: this.matchedContact,
        },
        buttons: [
          {
            text: 'Add new',
            onClick: wizard => wizard.goToStep(CreateNewContactComponent.ID),
          },
          {
            text: 'Send Message',
            onClick: () => this.store$.dispatch(
              openDialog({
                dialogData: {
                  title: 'Send Email',
                  content: RContentComponent,
                  componentData: {
                    data: {
                      tag: 'send-email',
                    },
                    item: {
                      contact_email: this.contactEmail,
                    },
                    subject: this.messages[0].subject,
                  },
                  dialogMinWidth: '1000px',
                  canClose: true,
                },
              }),
            ),
          },
          {
            text: 'Spam',
            onClick: wizard =>
              this.store$.dispatch(
                openDialog({
                  dialogData: {
                    title: 'Spam message?',
                    buttons: [
                      {
                        text: 'Ok',
                        onClick: dialog => {
                          this.messagesService
                            .setSpam(this.messages[0].message_id, true)
                            .subscribe(
                              result => {
                                dialog.closeDialog();
                                wizard.notifyFinish();
                              },
                              (error: HttpErrorResponse) => {
                                this.store$.dispatch(
                                  openSnackbar({
                                    snackbarData: {
                                      data: {
                                        type: 'error',
                                        message: error.error,
                                      },
                                    },
                                  }),
                                );
                                dialog.closeDialog();
                                wizard.notifyFinish();
                              },
                            );
                        },
                        color: ButtonColor.BLUE,
                        size: ButtonSize.NORMAL,
                      },
                    ],
                    content:
                      'You are about to flag this message as spam.\n' +
                      'If you flag this message as spam, then the message will move to the Spam folder under the inbox and send all future emails from this address to the Spam folder.',
                  },
                }),
              ),
            color: ButtonColor.ORANGE,
            style: 'outline',
          },
          {
            text: 'Remove',
            onClick: wizard =>
              this.store$.dispatch(
                openDialog({
                  dialogData: {
                    title: 'Remove message?',
                    buttons: [
                      {
                        text: 'Ok',
                        onClick: dialog => {
                          const firstMessage = this.messages[0];

                          if (firstMessage) {
                            const content = firstMessage.content;

                            this.contactsService
                              .setMessageToOkGotIt(this.contactId)
                              .subscribe(result => {
                                this.store$.dispatch(openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: 'Operation successful',
                                      type: 'success',
                                    },
                                  },
                                }));
                                dialog.closeDialog();
                                wizard.notifyFinish();
                              }, err => {
                                this.store$.dispatch(openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: err.error,
                                      type: 'error',
                                    },
                                  },
                                }));
                                dialog.closeDialog();
                                wizard.notifyFinish();
                              });
                          }
                        },
                        color: ButtonColor.BLUE,
                        size: ButtonSize.NORMAL,
                      },
                    ],
                    content:
                      'You are about to remove this message.\n' +
                      'You should only use Remove if the no match email was a system generated reply.\n' +
                      'If a real person replied to your email DO NOT USE remove.\n' +
                      'You should search for the alternate email address of an existing contact or add a new contact.',
                  },
                }),
              ),
            color: ButtonColor.RED,
            style: 'outline',
          },
          {
            text: 'Search',
            onClick: wizardComponent => {
              const component = wizardComponent.getInstance<SearchForContactComponent>(SearchForContactComponent.ID);

              if (component) {
                component.updateSearch();
              }
            },
          },
        ],
      },
      {
        title: 'Create new contact',
        component: CreateNewContactComponent,
        id: CreateNewContactComponent.ID,
        componentData: {
          messages: this.messages,
          contactEmail: this.contactEmail,
          accountId: this.accountId,
        },
        buttons: [
          {
            text: 'Back',
            onClick: wizardComponent =>
              wizardComponent.goToStep(SearchForContactComponent.ID),
            color: ButtonColor.WHITE,
          },
          {
            text: 'Submit',
            onClick: async wizardComponent => {
              if (!await wizardComponent.validateComponent()) {
                return false;
              }
              wizardComponent.collectCurrentStepData();
              const data = wizardComponent.collectComponentData();
              this.contactsService
                .updateContact(
                  this.contactId,
                  data[CreateNewContactComponent.ID],
                )
                .subscribe(result => {
                  this.dialogRef.closeDialog();
                  wizardComponent.notifyFinish();
                });
            },
          },
        ],
      },
    ];

    if (this.userSession.popup_tips) {
      this.store$.dispatch(
        openDialog({
          dialogData: {
            content: InfoTipsComponent,
            title: 'Tips',
            canClose: true,
            dialogMinWidth: '700px',
            componentData: {
              type: 'no-match-action',
            },
          },
        }),
      );
    }
  }

  onWizardFinish($event: any) {
    this.dialogRef.closeDialog();
    this.router.navigate(['/messages']);
  }
}
